import type { DeviceKind } from '~/generated/graphql';

export function capitalize(s: string): string {
  const head = s[0].toUpperCase();
  const tail = s.slice(1).toLowerCase();
  return `${head}${tail}`;
}

export function titleize(str: string): string {
  return str
    .split('_')
    .map((word) => capitalize(word))
    .join(' ');
}

export function unCamelize(str: string): string {
  return str
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();
}

export const formatDeviceKind = (kind: DeviceKind) => (kind === 'WEBOS' ? 'LG' : capitalize(kind));
